export const Nj_WORDS = ['NjUŠKA']
